import { constraintCatalogById } from '@bp/shared-planung-utils';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { openTopicKey } from '../../utils/timetable/openTopics';

/**
 * Verständlicher Name einer Solver-Regel (cid wie `class1917`, auch mit Tier-Suffix `-hard`/Paket-Präfix).
 * Unbekannte Regeln: Katalog-Label, sonst allgemein. Genutzt vom Lauf-Banner („Noch offen“) und vom Score-Debug.
 */
export const useConstraintLabel = () => {
  const { t } = useTranslation();
  return useCallback(
    (name: string): string => {
      const id = openTopicKey(name);
      // Der Katalog führt viele Regeln je Stufe (`teacher0001-hard`), daher zuerst mit vollem Namen suchen.
      const fullId = name.includes('/') ? (name.split('/').pop() ?? name) : name;
      // Ausgeschriebene Schlüssel, damit i18next-parser sie findet.
      const texts: Record<string, string> = {
        subject2001: t('pinboard.generate.runBanner.openTopics.topic.subject2001'),
        subject2002: t('pinboard.generate.runBanner.openTopics.topic.subject2002'),
        subject2005: t('pinboard.generate.runBanner.openTopics.topic.subject2005'),
        subject2007: t('pinboard.generate.runBanner.openTopics.topic.subject2007'),
        subject2008: t('pinboard.generate.runBanner.openTopics.topic.subject2008'),
        subject2009: t('pinboard.generate.runBanner.openTopics.topic.subject2009'),
        subject2900: t('pinboard.generate.runBanner.openTopics.topic.subject2900'),
        class1001: t('pinboard.generate.runBanner.openTopics.topic.class1001'),
        'class1001-window': t('pinboard.generate.runBanner.openTopics.topic.class1001-window'),
        'class1003-nogap': t('pinboard.generate.runBanner.openTopics.topic.class1003-nogap'),
        class1004: t('pinboard.generate.runBanner.openTopics.topic.class1004'),
        class1005: t('pinboard.generate.runBanner.openTopics.topic.class1005'),
        class1900: t('pinboard.generate.runBanner.openTopics.topic.class1900'),
        class1901: t('pinboard.generate.runBanner.openTopics.topic.class1901'),
        class1902: t('pinboard.generate.runBanner.openTopics.topic.class1902'),
        class1914: t('pinboard.generate.runBanner.openTopics.topic.class1914'),
        class1915: t('pinboard.generate.runBanner.openTopics.topic.class1915'),
        class1916: t('pinboard.generate.runBanner.openTopics.topic.class1916'),
        class1917: t('pinboard.generate.runBanner.openTopics.topic.class1917'),
        class1918: t('pinboard.generate.runBanner.openTopics.topic.class1918'),
        class1919: t('pinboard.generate.runBanner.openTopics.topic.class1919'),
        class1920: t('pinboard.generate.runBanner.openTopics.topic.class1920'),
        teacher0008: t('pinboard.generate.runBanner.openTopics.topic.teacher0008'),
        teacher0009: t('pinboard.generate.runBanner.openTopics.topic.teacher0009'),
        teacher0900: t('pinboard.generate.runBanner.openTopics.topic.teacher0900'),
        teacher0901: t('pinboard.generate.runBanner.openTopics.topic.teacher0901'),
        teacher0902: t('pinboard.generate.runBanner.openTopics.topic.teacher0902'),
        room3002: t('pinboard.generate.runBanner.openTopics.topic.room3002'),
        room3003: t('pinboard.generate.runBanner.openTopics.topic.room3003'),
        room3900: t('pinboard.generate.runBanner.openTopics.topic.room3900'),
        sys9001: t('pinboard.generate.runBanner.openTopics.topic.sys9001'),
      };
      return (
        texts[id] ??
        constraintCatalogById[fullId]?.label ??
        constraintCatalogById[id]?.label ??
        t('pinboard.generate.runBanner.openTopics.otherRule')
      );
    },
    [t],
  );
};
